import reportError from 'ha/helpers/bugsnag/reportError';

import { Actions } from './constants';

export default (cookies = {}) => {
  let validCookies = true;

  if (!('get' in cookies) || !('set' in cookies)) {
    if (process && process.env && process.env.NODE_ENV !== 'production') {
      throw new Error(
        'Your cookie object must implement get and set function,  {get : function(name){/*...*/}, set : function(name, value, options){/*...*/}}',
      );
    }
    validCookies = false;
  }

  const actionsMap = {};

  actionsMap[Actions.COOKIES_GET] = action => {
    try {
      return cookies.get(action.payload.name);
    } catch (error) {
      reportError(error);

      return undefined;
    }
  };
  actionsMap[Actions.COOKIES_SET] = action => {
    try {
      cookies.set(
        action.payload.name,
        action.payload.value,
        action.payload.options,
      );
    } catch (error) {
      reportError(error);
    }
  };

  actionsMap[Actions.COOKIES_EXPIRE] = action => {
    try {
      cookies.set(action.payload.name, undefined);
    } catch (error) {
      reportError(error);
    }
  };

  actionsMap[Actions.COOKIES_REMOVE] = action => {
    try {
      // if cookies lib has remove support
      if (cookies.remove) {
        cookies.remove(action.payload.name, action.payload.options);
      } else {
        cookies.set(action.payload.name, undefined);
      }
    } catch (error) {
      reportError(error);
    }
  };

  return () => next => action => {
    const currentActionHandler = actionsMap[action.type];

    if (validCookies && currentActionHandler) {
      return currentActionHandler(action);
    }
    if (!validCookies && Boolean(currentActionHandler)) {
      if (process && process.env && process.env.NODE_ENV !== 'production') {
        throw new Error(
          'Your cookie object must implement get and set function,  {get : function(name){/*...*/}, set : function(name, value, options){/*...*/}}',
        );
      }

      return null;
    }

    return next(action);
  };
};
